import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { X, ExternalLink, CheckCircle2 } from 'lucide-react';
import { PORTAL_ROUTES } from 'utils/constants';
import MessageList from 'components/Conversation/Message/List';
import ReplyBox from 'components/Conversation/Message/ReplyBox';

function ConversationPopup({ conversation: target, onClose }) {
  const [sentMessage, setSentMessage] = useState(null);
  const [conversation, setConversation] = useState(target);

  const { state, title, encodedId } = conversation || {};

  useEffect(() => {
    setConversation(target);
  }, [target])

  const closeConversation = () => {
    setConversation((_conversation) => ({ ...(_conversation || {}), state: 'closed' }));
  }

  return (
    <div className="fixed bottom-0 right-0 z-50 w-full h-[540px] sm:bottom-4 sm:right-4 sm:w-[380px] sm:rounded-2xl bg-white shadow-2xl flex flex-col overflow-hidden border border-gray-100">
      {/* Header */}
      <div className="shrink-0 bg-teamcare-blue px-4 py-3 flex items-center gap-2 text-white">
        <span className="font-semibold text-sm flex-1 truncate min-w-0">{title}</span>
        <span className="shrink-0 text-[10px] font-bold uppercase tracking-wide bg-white/20 px-2 py-0.5 rounded-full border border-white/30">
          {state}
        </span>
        <Link
          to={`${PORTAL_ROUTES.CONVERSATIONS}/${encodedId}`}
          className="p-1 rounded hover:bg-white/20 transition-colors shrink-0"
          title="Open full conversation"
        >
          <ExternalLink size={15} />
        </Link>
        <button
          onClick={onClose}
          className="p-1 rounded hover:bg-white/20 transition-colors shrink-0"
        >
          <X size={15} />
        </button>
      </div>

      {/* Messages */}
      <MessageList conversationId={encodedId} sentMessage={sentMessage} />

      {/* Footer */}
      {state === 'closed' ? (
        <div className="shrink-0 border-t border-base-200 px-4 py-4 flex items-center justify-center gap-2 text-sm text-base-content/50">
          <CheckCircle2 size={18} className="text-success-500 shrink-0" />
          This conversation has been resolved.
        </div>
      ) : (
        <ReplyBox conversationId={encodedId} onSent={setSentMessage} onClosed={closeConversation} />
      )}
    </div>
  );
};

export default ConversationPopup;
